module.exports = "/_next/static/images/6e4089ff22ce0c7e05612b8a62ed582a-card-new.svg";